/**
 * Only the production app sends data to PostHog: app.cleanlist.ai, and
 * app.clugtm.com, the same app under the Clu brand in Canada. Staging, deploy
 * previews and localhost still load feature flags, but capture nothing — no
 * events, no session replays, no exceptions — so dev traffic never shows up in
 * the analytics, Replay Vision or error tracking that prod issues are triaged
 * from.
 */
export const posthogCapturesOn = (hostname: string): boolean =>
  hostname === 'app.cleanlist.ai' || hostname === 'app.clugtm.com';

export const posthogCapturesHere = (): boolean =>
  posthogCapturesOn(window.location.hostname);
